import { render, staticRenderFns } from "./MasterTab.vue?vue&type=template&id=7c3efc28"
import script from "./MasterTab.vue?vue&type=script&lang=js"
export * from "./MasterTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports